// extracted by mini-css-extract-plugin
export default {"container":"Mr-z","brandName":"Nr-z","productName":"Or-z","aboveGalleryInfo":"Pr-z","belowGalleryInfo":"Qr-z","breakLongProductName":"Rr-z"};